import React from 'react';
import { Paper, Box } from '@mui/material';
import MaterialTypography from '../../../../components/MaterialTypography';
import MaterialBox from '../../../../components/MaterialBox';

const BugsActionsCard = ({ title, total, openCount, closedCount, type }) => {

    const totalCalc = openCount + closedCount;
    const percentage = totalCalc > 0 ? (openCount / totalCalc) * 100 : 0;

    return (
        <Paper
            elevation={0}
            sx={{
                padding: 1,
                borderRadius: 2,
                width: '100%',
            }}
        >
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                <MaterialBox sx={{ display: 'flex', flexDirection: 'row', gap: 0.5, alignItems: 'center' }}>
                    <MaterialBox sx={{ width: '6px', height: '14px', backgroundColor: '#7783c9', borderRadius: 1 }} />
                    <MaterialTypography variant="h6" fontWeight="bold" sx={{ fontSize: '0.9rem' }}>
                        {title}
                    </MaterialTypography>
                </MaterialBox>
                <Box display="flex" flexDirection="column" alignItems="flex-end">
                    <MaterialTypography variant="h5" fontWeight="bold">
                        {total}
                    </MaterialTypography>
                </Box>
            </Box>

            <Box sx={{ position: 'relative', height: '18px', mb: 1, mt: 0.5 }}>
                <Box
                    sx={{
                        position: 'absolute',
                        left: `${percentage}%`,
                        top: '-20px',
                        transform: 'translateX(-50%)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        zIndex: 2
                    }}
                >
                    <Box sx={{
                        width: '8px',
                        height: '10px',
                        backgroundColor: 'black',
                        borderRadius: '2px'
                    }} />
                    <Box sx={{
                        width: 0,
                        height: 0,
                        borderLeft: '4px solid transparent',
                        borderRight: '4px solid transparent',
                        borderTop: '5px solid black',
                    }} />
                </Box>

                <Box
                    sx={{
                        width: '100%',
                        height: '100%',
                        borderRadius: '6px',
                        overflow: 'hidden',
                        backgroundColor: '#f5f5f5',
                        backgroundImage: `repeating-linear-gradient(
                            135deg,
                            #f0f0f0,
                            #f0f0f0 4px,
                            #e0e0e0 4px,
                            #e0e0e0 8px
                        )`,
                        position: 'relative'
                    }}
                >
                    <Box
                        sx={{
                            width: `${percentage}%`,
                            height: '100%',
                            background: 'linear-gradient(90deg, #939eb5 0%, #b0bccf 100%)',
                            borderRadius: '6px',
                            border: '1px solid white',
                            boxShadow: '0 2px 4px rgba(76, 110, 245, 0.2)'
                        }}
                    />
                </Box>
            </Box>

            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                    <MaterialTypography variant="body2" fontWeight="bold" sx={{ lineHeight: 1 }}>
                        {openCount}
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem', lineHeight: 1 }}>
                        Open Bugs
                    </MaterialTypography>
                </Box>
                <Box textAlign="right" sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                    <MaterialTypography variant="body2" fontWeight="bold" color="text.secondary" sx={{ lineHeight: 1 }}>
                        {closedCount}
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem', lineHeight: 1 }}>
                        Resolved Bugs
                    </MaterialTypography>
                </Box>
            </Box>
        </Paper>
    );
};

export default BugsActionsCard;
